export const BASE_URL: string = import.meta.env.VITE_APP_BACKEND_DOMAIN_NAME || ''

// Warn if BASE_URL is not set
if (!BASE_URL && typeof window !== 'undefined') {
  console.warn('VITE_APP_BACKEND_DOMAIN_NAME is not set. API calls may fail.')
}

export const API_ROUTES = {
  BASE_URL,
  USER_LOGIN: `${BASE_URL}/user-login`,
  USER_REGISTER: `${BASE_URL}/user-register`,
  USER_JWT_REFRESH: `${BASE_URL}/user-jwt-refresh`,
  USER_LOGOUT: `${BASE_URL}/user-logout`,
  USER_GET_CURRENT: `${BASE_URL}/user-get-current`,
  USER_UPDATE: `${BASE_URL}/user-update`,
  USER_UPDATE_BY_ID: (userId: number): string => `${BASE_URL}/users/${userId}/update`,
  USER_UPLOAD_AVATAR: `${BASE_URL}/upload-user-avatar-image`,
  DELETE_USER_AVATAR: `${BASE_URL}/delete-user-avatar-image`,
  USER_FORGOT_PASSWORD: `${BASE_URL}/forgot-password`,
  USER_RESET_PASSWORD: (token: string | number): string => `${BASE_URL}/change-password/${token}`,
  CHECK_USER_EXISTS: `${BASE_URL}/check-username-uniqueness`,
  CHECK_EMAIL_EXISTS: `${BASE_URL}/check-email-uniqueness`,
  GET_USER_LIST: `${BASE_URL}/get-user-list`,

  CHECK_USER_ROLE: `${BASE_URL}/check-user-role`,

  GET_USERS: `${BASE_URL}/users/`,
  GET_ALL_USERS: `${BASE_URL}/users/all/`,
  GET_ALL_GUIDES: `${BASE_URL}/get-guides/`,
  GET_GUIDES_AND_MENTORS: `${BASE_URL}/get-guides-and-mentors/`,

  GET_EMPLOYER_LIST: `${BASE_URL}/employers/get-employers-list`,
  CREATE_EMPLOYER: `${BASE_URL}/employers/create-employer`,
  CHECK_EMPLOYER_EXISTENCE: `${BASE_URL}/employers/check-employer-existence/`,
  CHECK_ROLENAME_EXISTENCE: `${BASE_URL}/employers/check-role-name-existence/`,
  UPDATE_EMPLOYER: (employerId: string | number): string =>
    `${BASE_URL}/employers/update-employer/${employerId}/`,
  GET_EMPLOYERS_OPTIONS: `${BASE_URL}/employers/get-employers-options/`,

  GET_BACHELORS_DEGREE_OPTIONS: `${BASE_URL}/get-bachelors-degree`,
  GET_GENDERS: `${BASE_URL}/get-genders`,
  GET_USER_JOB_ROLES: `${BASE_URL}/get-user-job-roles`,
  GET_COUNTRIES: `${BASE_URL}/get-countries`,
  GET_CITIES: `${BASE_URL}/get-cities`,
  CHECK_USERNAME_UNIQUENESS: `${BASE_URL}/check-username-uniqueness`,
  CHECK_EMAIL_UNIQUENESS: `${BASE_URL}/check-email-uniqueness`,
  // GET_USER_PROFILE: (username: string) => `${BASE_URL}/get-user-profile/${username}`,
  GET_USER_PROFILE: (username: string) => `${BASE_URL}/profiles/by-username/${username}/`,
  EDIT_USER_PROFILE: `${BASE_URL}/profiles/edit/`,
  UPLOAD_USER_PROFILE_PHOTO: `${BASE_URL}/profiles/photos/`,
  DELETE_USER_PROFILE_PHOTO: (photoId: string) => `${BASE_URL}/profiles/photos/${photoId}/`,
  REORDER_PROFILE_PHOTOS: `${BASE_URL}/profiles/photos/reorder/`,
  MANAGE_USER_PROFILE: (profileId: string) => `${BASE_URL}/profiles/${profileId}/`,

  GET_CURRICULUM_LIST: (expeditionId: string) =>
    `${BASE_URL}/curriculum/get-progress-list/${expeditionId}`,
  GET_CURRICULUM_BY_ID: (curriculumId: string) =>
    `${BASE_URL}/curriculum/get-progress/${curriculumId}`,
  GET_CURRICULUM_BY_WEEK_ID: (id: string, expeditionId: string) =>
    `${BASE_URL}/curriculum/get-progress-by-week/${id}/expedition/${expeditionId}`,
  GET_PROGRESS_OF_CURRENT_WEEK: (expeditionId: string) =>
    `${BASE_URL}/curriculum/get-current-week/${expeditionId ? expeditionId : ''}`,
  GET_PROGRESS_BY_WEEK: (weekId: string, expeditionId: string) =>
    `${BASE_URL}/curriculum/get-progress-by-week/${weekId}/expedition/${expeditionId}`,
  UPDATE_PROGRESS_STATUS: (id: string) => `${BASE_URL}/curriculum/update-progress-status/${id}/`,
  GET_ADVENTURER_STATS: (expeditionId: string) =>
    `${BASE_URL}/curriculum/get-adventurer-stats/${expeditionId}`,
  GET_EXPEDITION_PATH_STEPS: (expeditionId: string) =>
    `${BASE_URL}/curriculum/guide/get-expedition-path-steps/${expeditionId}`,

  GET_PATHS: `${BASE_URL}/curriculum/paths/`,

  GET_CURRENT_WEEK_BY_EXPEDITION_ID: (expeditionId: string) =>
    `${BASE_URL}/curriculum/get-current-week/${expeditionId}`,
  GET_EXPEDITION_BY_USER_ID: (userId: string) =>
    `${BASE_URL}/curriculum/user/${userId}/expedition/`,

  GET_EXPEDITIONS_LIST: `${BASE_URL}/curriculum/get-expeditions-list`,
  GET_EXPEDITION_TYPES: `${BASE_URL}/curriculum/expedition-type/`,
  CREATE_EXPEDITION: `${BASE_URL}/curriculum/create-new-expedition/`,
  GET_ADVENTURERS_PROGRESS: (expeditionId: string) =>
    `${BASE_URL}/curriculum/guide/get-adventurers-progress/${expeditionId}`,
  GET_ADVENTURER_PROGRESS_BY_WEEK: (expeditionId: string, userId: string, weekId: string) =>
    `${BASE_URL}/curriculum/get-progress-list/${expeditionId}/${userId}/by-week/${weekId}`,

  GET_ADVENTURERS_BY_EXPEDITION_ID: (expeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/adventurers/`,
  GET_GUIDES_BY_EXPEDITION_ID: (expeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/guides/`,
  ADD_GUIDES_TO_EXPEDITION: (expeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/add-guides/`,
  ADD_ADVENTURERS_TO_EXPEDITION: (expeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/add-adventurers/`,
  MANAGE_EXPEDITION_MEMBERS: (expeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/manage-members/`,
  GET_EXPEDITION_BY_ID: (expeditionId: string) =>
    `${BASE_URL}/curriculum/get-expedition/${expeditionId}/`,

  CREATE_PERSONAL_NOTE: `${BASE_URL}/curriculum/create-personal-note`,
  UPDATE_PERSONAL_NOTE: (noteId: number) => `${BASE_URL}/curriculum/update-personal-note/${noteId}`,
  GET_PERSONAL_NOTE: (progressId: number) =>
    `${BASE_URL}/curriculum/get-personal-note/${progressId}`,
  CREATE_PATH_STEP_REVIEW: (expeditionId: string) =>
    `${BASE_URL}/curriculum/create-path-step-review/${expeditionId}`,

  UPDATE_PATH_STEP: (stepId: number) => `${BASE_URL}/curriculum/update-path-step/${stepId}/`,
  DELETE_PATH_STEP: (stepId: number) => `${BASE_URL}/curriculum/delete-path-step/${stepId}/`,
  CREATE_PATH_STEP_WITH_TASK: (pathId: number) =>
    `${BASE_URL}/curriculum/paths/${pathId}/create_step_with_task/`,
  REORDER_PATH_STEP: `${BASE_URL}/curriculum/path-step/reorder/`,
  REORDER_PATH_STEP_BATCH: `${BASE_URL}/curriculum/path-step/reorder-batch/`,
  GET_SECTIONS: `${BASE_URL}/curriculum/sections/`,
  BATCH_UPDATE_PATH_STEPS: `${BASE_URL}/curriculum/path-step/batch-update/`,

  GET_LATEST_REVIEW: (taskId: number) => `${BASE_URL}/curriculum/get-latest-review/${taskId}`,
  GET_REVIEW_HISTORY: (expeditionId: number) =>
    `${BASE_URL}/curriculum/expedition/${expeditionId}/path-steps-with-reviews/`,
  GET_USER_REVIEWS: (userId: number) => `${BASE_URL}/curriculum/user/${userId}/reviews/`,
  GET_PATH_STEP_REVIEWS: (pathStepId: number) =>
    `${BASE_URL}/curriculum/path-step/${pathStepId}/reviews/`,

  SWITCH_USER_EXPEDITION: (sourceExpeditionId: string) =>
    `${BASE_URL}/curriculum/expedition/${sourceExpeditionId}/switch-user-expedition/`,

  GET_USER_WEEK_PREFERENCE: (userId: number) =>
    `${BASE_URL}/curriculum/fellow-week-access/${userId}/`,
  SET_USER_WEEK_PREFERENCE: (userId: number) =>
    `${BASE_URL}/curriculum/fellow-week-access/${userId}/`,
  DELETE_USER_WEEK_PREFERENCE: (userId: number) =>
    `${BASE_URL}/curriculum/fellow-week-access/${userId}/`,

  DELETE_PROFILE_PHOTO: (photoId: string) => `${BASE_URL}/profiles/photos/${photoId}/`,

  GET_FELLOW_DATA: `${BASE_URL}/profiles/fellow-data/`,
  GET_FELLOW_DATA_BY_USERNAME: (username: string) =>
    `${BASE_URL}/profiles/fellow-data/by-username/${username}/`,
  EDIT_FELLOW_DATA: (username: string) =>
    `${BASE_URL}/profiles/fellow-data/by-username/${username}/`,
  CREATE_INTERNAL_COMMENT: `${BASE_URL}/profiles/internal-comment/create-by-username/`,
  EDIT_INTERNAL_COMMENT: (commentId: string) =>
    `${BASE_URL}/profiles/internal-comments/${commentId}/`,

  GET_ALL_FELLOW_DATA: `${BASE_URL}/profiles/fellow-data/`,
  GET_ALL_FELLOWS_PAGINATED: `${BASE_URL}/profiles/fellow-data/all/`,
  GET_ADVENTURERS_BY_BATCH: `${BASE_URL}/profiles/fellow-data/grouped-by-batch/`,
  GET_ADVENTURERS_BY_BATCH_ID: (batchId: string) =>
    `${BASE_URL}/profiles/fellow-data/by-batch/${batchId}/`,
  GET_ADVENTURERS_BY_EXPEDITION: (expeditionId: string) =>
    `${BASE_URL}/profiles/fellow-data/by-expedition/${expeditionId}/`,
  GET_ADVENTURERS_BY_POD: (podId: string | number) =>
    `${BASE_URL}/profiles/fellow-data/by-pod/${podId}/`,
  GET_BATCH_CHOICES: `${BASE_URL}/profiles/fellow-data/batch-choices/`,

  CREATE_ADVENTURER_NOTE: `${BASE_URL}/curriculum/fellow-progress-notes/`,
  EDIT_ADVENTURER_NOTE: (noteId: string) =>
    `${BASE_URL}/curriculum/fellow-progress-notes/${noteId}/`,
  GET_ADVENTURER_NOTES_BY_EXPEDITION_AND_WEEK: (expeditionId: string, week: string) =>
    `${BASE_URL}/curriculum/fellow-progress-notes/by-expedition-and-week/?expedition_id=${expeditionId}&week=${week}`,
  GET_ADVENTURER_NOTES_BY_EXPEDITION_AND_ADVENTURER: (
    expeditionId: string,
    adventurerId?: string | number
  ) =>
    `${BASE_URL}/curriculum/fellow-progress-notes/by-expedition-and-adventurer/?expedition_id=${expeditionId}${adventurerId ? `&adventurer_id=${adventurerId}` : ''}`,

  GET_FELLOW_REPORTS: `${BASE_URL}/reports/fellow-reports/`,
  GET_USER_FELLOW_REPORTS: (username: string) =>
    `${BASE_URL}/reports/fellow-reports/by-user/${username}/`,
  SUBMIT_FELLOW_REPORT: `${BASE_URL}/reports/fellow-reports/submit/`,
  ISSUE_FELLOW_STRIKE: `${BASE_URL}/reports/fellow-reports/issue_strike/`,
  REVIEW_FELLOW_REPORT: (reportId: string) =>
    `${BASE_URL}/reports/fellow-reports/${reportId}/review/`,
  REVOKE_FELLOW_REPORT: (reportId: string) =>
    `${BASE_URL}/reports/fellow-reports/${reportId}/revoke_strike/`,
  PATCH_FELLOW_REPORT: (reportId: string) => `${BASE_URL}/reports/fellow-reports/${reportId}/`,
  DELETE_REPORT: (id: number) => `${BASE_URL}/reports/${id}/`,

  GET_PROGRAM_GRADUATION_STATUS_CHOICES: `${BASE_URL}/profiles/fellow-data/program-graduation-status-choices/`,
  GET_CODING_STATUS_CHOICES: `${BASE_URL}/profiles/fellow-data/coding-status-choices/`,
  MY_PROGRAM_GOALS: `${BASE_URL}/profiles/fellow-data/my-goals/`,

  GET_INTERNAL_COMMENTS: `${BASE_URL}/profiles/internal-comments/`,
  GET_APPLICANT_PROFILE: (userId: string | number) => `${BASE_URL}/job_applications/applicant-profiles/${userId}/`,
  GET_GUIDE_TESTIMONIALS: (fellowId: string | number) => `${BASE_URL}/profiles/guide-testimonials/?fellow_id=${fellowId}`,
  CREATE_GUIDE_TESTIMONIAL: `${BASE_URL}/profiles/guide-testimonials/`,
  UPDATE_GUIDE_TESTIMONIAL: (id: string | number) => `${BASE_URL}/profiles/guide-testimonials/${id}/`,
  DELETE_GUIDE_TESTIMONIAL: (id: string | number) => `${BASE_URL}/profiles/guide-testimonials/${id}/`,
  GET_USER_JOB_APPLICATION_STATISTICS: (userId: string | number) => `${BASE_URL}/job_applications/user-statistics/${userId}/`,
  GET_EXPEDITION_JOB_APPLICATION_STATISTICS: (expeditionId: string | number) =>
    `${BASE_URL}/job_applications/expedition-statistics/${expeditionId}/`,
  GET_POD_JOB_APPLICATION_STATISTICS: (podId: string | number) =>
    `${BASE_URL}/job_applications/pod-statistics/${podId}/`,

  // Subscription API Routes
  SUBSCRIPTION_ASSIGNED_PLANS: `${BASE_URL}/subscriptions/my-assigned-plan/`,
  SUBSCRIPTION_MY_OFFER: `${BASE_URL}/subscriptions/my-offer/`,
  SUBSCRIPTION_MY_PRODUCT_PURCHASES: `${BASE_URL}/subscriptions/my-product-purchases/`,
  SUBSCRIPTION_PRODUCTS: `${BASE_URL}/subscriptions/products/`,
  SUBSCRIPTION_ASSIGN_PLAN: (userId: number | string) => `${BASE_URL}/subscriptions/user/${userId}/assign-plan/`,
  SUBSCRIPTION_ASSIGN_PRODUCT: (userId: number | string) =>
    `${BASE_URL}/subscriptions/user/${userId}/assign-product/`,
  SUBSCRIPTION_PLAN_BY_ID: (id: string | number) => `${BASE_URL}/subscriptions/plans/${id}/`,
  SUBSCRIPTION_CUSTOMERS: `${BASE_URL}/subscriptions/customers/`,
  SUBSCRIPTION_PAYMENT_METHODS: `${BASE_URL}/subscriptions/payment-methods/`,
  SUBSCRIPTION_CURRENT: `${BASE_URL}/subscriptions/current/`,
  SUBSCRIPTION_CREATE: `${BASE_URL}/subscriptions/`,
  SUBSCRIPTION_PAYMENTS: `${BASE_URL}/subscriptions/payments/`,
  SUBSCRIPTION_SETUP_INTENT: `${BASE_URL}/subscriptions/setup-intent/`,
  SUBSCRIPTION_ATTACH_PAYMENT_METHOD: `${BASE_URL}/subscriptions/attach-payment-method/`,
  SUBSCRIPTION_SET_DEFAULT_PAYMENT_METHOD: `${BASE_URL}/subscriptions/set-default-payment-method/`,
  SUBSCRIPTION_ACCESS_STATUS: `${BASE_URL}/subscriptions/access/status/`,
  
  // Stripe Checkout API Routes
  SUBSCRIPTION_CHECKOUT_SETUP_CARD: `${BASE_URL}/subscriptions/checkout/setup-card/`,
  SUBSCRIPTION_CHECKOUT_CREATE_SUBSCRIPTION: `${BASE_URL}/subscriptions/checkout/create-subscription/`,
  SUBSCRIPTION_CHECKOUT_CREATE_PRODUCT_PURCHASE: `${BASE_URL}/subscriptions/checkout/create-product-purchase/`,
  SUBSCRIPTION_CHECKOUT_SESSION: `${BASE_URL}/subscriptions/checkout/session/`,
  SUBSCRIPTION_RETRY_PAYMENT: `${BASE_URL}/subscriptions/retry-payment/`,

  // Social Auth API Routes
  SOCIAL_AUTH_GOOGLE_LOGIN: `${BASE_URL}/auth/google/login/`,
  SOCIAL_AUTH_LINKEDIN_LOGIN: `${BASE_URL}/auth/linkedin/login/`,
  SOCIAL_AUTH_PROFILE_STATUS: `${BASE_URL}/users/profile-status/`,
  SOCIAL_AUTH_COMPLETE_PROFILE: `${BASE_URL}/users/complete-profile/`,

  // Personalized Curriculum (Campus) - Fellow endpoints
  CAMPUS_TEMPLATES: `${BASE_URL}/personal-curriculum/templates/`,
  CAMPUS_TEMPLATE_DETAIL: (id: number | string): string => `${BASE_URL}/personal-curriculum/templates/${id}/`,
  CAMPUS_MY_CURRICULUM: `${BASE_URL}/personal-curriculum/`,
  CAMPUS_BUILD: `${BASE_URL}/personal-curriculum/build/`,
  CAMPUS_COMMIT: `${BASE_URL}/personal-curriculum/commit/`,
  CAMPUS_CURRENT_WEEK: `${BASE_URL}/personal-curriculum/current-week/`,
  CAMPUS_ALL_STEPS: `${BASE_URL}/personal-curriculum/all-steps/`,
  CAMPUS_ACTIVITY: `${BASE_URL}/personal-curriculum/activity/`,
  CAMPUS_BY_SECTION: (templateId: number | string): string => `${BASE_URL}/personal-curriculum/by-section/${templateId}/`,
  CAMPUS_ADD_TRACK: `${BASE_URL}/personal-curriculum/add-track/`,
  CAMPUS_REMOVE_TRACK: `${BASE_URL}/personal-curriculum/remove-track/`,
  CAMPUS_PREVIOUS_PROGRAMS: `${BASE_URL}/personal-curriculum/previous/`,
  CAMPUS_MY_POD: `${BASE_URL}/personal-curriculum/my-pod/`,
  CAMPUS_REORDER_STEPS: `${BASE_URL}/personal-curriculum/steps/reorder/`,
  CAMPUS_ADD_PERSONAL_STEP: `${BASE_URL}/personal-curriculum/steps/add-personal/`,
  CAMPUS_DELETE_STEP: (id: number | string): string => `${BASE_URL}/personal-curriculum/steps/${id}/`,
  CAMPUS_UPDATE_STEP_STATUS: (stepId: number | string): string => `${BASE_URL}/personal-curriculum/steps/${stepId}/update-status/`,
  CAMPUS_STEP_REVIEWS: (stepId: number | string): string => `${BASE_URL}/personal-curriculum/steps/${stepId}/reviews/`,
  CAMPUS_STEP_REVIEW_LATEST: (stepId: number | string): string => `${BASE_URL}/personal-curriculum/steps/${stepId}/reviews/latest/`,
  CAMPUS_CREATE_REVIEW: `${BASE_URL}/personal-curriculum/reviews/create/`,

  // Personalized Curriculum (Campus) - Guide endpoints
  CAMPUS_GUIDE_PODS: `${BASE_URL}/personal-curriculum/guide/pods/`,
  CREATE_POD: `${BASE_URL}/personal-curriculum/guide/pods/`,
  CAMPUS_GUIDE_POD_DETAIL: (id: number | string): string =>
    `${BASE_URL}/personal-curriculum/guide/pods/${id}/`,
  CAMPUS_GUIDE_POD_MEMBERS: (id: number | string): string =>
    `${BASE_URL}/personal-curriculum/guide/pods/${id}/members/`,
  CAMPUS_GUIDE_FELLOWS: `${BASE_URL}/personal-curriculum/guide/fellows/`,
  CAMPUS_GUIDE_FELLOW_DETAIL: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/`,
  CAMPUS_GUIDE_SET_WEEK: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/set-week/`,
  CAMPUS_GUIDE_ADD_STEP: (userId: number | string): string => `${BASE_URL}/personal-curriculum/${userId}/steps/add-by-guide/`,
  /** PUT — guide updates a fellow step (`/personal-curriculum/:userId/steps/:stepId/`). */
  CAMPUS_GUIDE_UPDATE_STEP: (userId: number | string, stepId: number | string): string =>
    `${BASE_URL}/personal-curriculum/${userId}/steps/${stepId}/`,
  CAMPUS_GUIDE_DELETE_STEP: (userId: number | string, stepId: number | string): string => `${BASE_URL}/personal-curriculum/${userId}/steps/${stepId}/delete/`,
  CAMPUS_GUIDE_REORDER_STEPS: (userId: number | string): string => `${BASE_URL}/personal-curriculum/${userId}/steps/reorder/`,
  CAMPUS_GUIDE_FELLOW_CURRICULUM: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/curriculum/`,
  CAMPUS_GUIDE_FELLOW_ALL_STEPS: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/all-steps/`,
  CAMPUS_GUIDE_PREVIOUS_PROGRAMS: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/previous/`,
  CAMPUS_GUIDE_BY_SECTION: (userId: number | string, templateId: number | string): string =>
    `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/by-section/${templateId}/`,
  CAMPUS_GUIDE_BUILD_CURRICULUM: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/build/`,
  CAMPUS_GUIDE_ADD_TRACK: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/add-track/`,
  CAMPUS_GUIDE_REMOVE_TRACK: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/remove-track/`,
  CAMPUS_GUIDE_COMMIT_PLAN: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/commit/`,
  CAMPUS_GUIDE_ADD_PERSONAL_STEP: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/steps/add-personal/`,
  CAMPUS_GUIDE_DELETE_FELLOW_STEP: (userId: number | string, stepId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/steps/${stepId}/`,
  CAMPUS_GUIDE_ACTIVITY: (userId: number | string): string => `${BASE_URL}/personal-curriculum/guide/fellows/${userId}/activity/`,
  CAMPUS_BROADCAST_STEP: `${BASE_URL}/personal-curriculum/broadcast-step/`,
  CAMPUS_PROGRESS_NOTES: `${BASE_URL}/personal-curriculum/progress-notes/`,
  CAMPUS_PROGRESS_NOTE_DETAIL: (noteId: number | string): string => `${BASE_URL}/personal-curriculum/progress-notes/${noteId}/`,

  // Onboarding admin endpoints
  ONBOARDING_NOT_ONBOARDED: `${BASE_URL}/profiles/onboarding/not-onboarded/`,
  ONBOARDING_LATEST_POD: `${BASE_URL}/profiles/onboarding/latest-pod/`,
  ONBOARDING_CHECKLIST: (userId: number): string => `${BASE_URL}/profiles/onboarding/checklist/${userId}/`,
  ONBOARDING_SEND_WELCOME_EMAIL: (userId: number): string => `${BASE_URL}/profiles/onboarding/send-welcome-email/${userId}/`,
  ONBOARDING_ASSIGN_POD: `${BASE_URL}/profiles/onboarding/assign-pod/`,
  ONBOARDING_PODS: `${BASE_URL}/profiles/onboarding/pods/`,

  // Staff: manage curriculum templates (tracks) CRUD
  CAMPUS_MANAGE_TEMPLATES: `${BASE_URL}/personal-curriculum/manage/templates/`,
  CAMPUS_MANAGE_TEMPLATE_DETAIL: (id: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/templates/${id}/`,
  CAMPUS_MANAGE_TEMPLATE_STEPS: (templateId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/templates/${templateId}/steps/`,
  CAMPUS_MANAGE_TEMPLATE_STEPS_REORDER: (templateId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/templates/${templateId}/steps/reorder/`,
  CAMPUS_MANAGE_TEMPLATE_STEP_DETAIL: (templateId: number | string, stepId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/templates/${templateId}/steps/${stepId}/`,
  CAMPUS_MANAGE_TASKS: `${BASE_URL}/personal-curriculum/manage/tasks/`,
  CAMPUS_MANAGE_TEMPLATES_SYNC_STEPS: `${BASE_URL}/personal-curriculum/manage/templates/sync-steps/`,
  // Admin: create a track (template + steps) from an uploaded CSV
  CAMPUS_MANAGE_TEMPLATES_IMPORT_CSV: `${BASE_URL}/personal-curriculum/manage/templates/import-csv/`,
  CAMPUS_MANAGE_PLANS: `${BASE_URL}/personal-curriculum/manage/plans/`,
  CAMPUS_MANAGE_TEMPLATE_PLANS: (templateId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/templates/${templateId}/plans/`,

  // Admin: per-fellow track access grants (manual one-time purchases)
  CAMPUS_MANAGE_TRACK_ACCESS: (userId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/fellows/${userId}/track-access/`,
  CAMPUS_MANAGE_TRACK_ACCESS_DETAIL: (userId: number | string, templateId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/fellows/${userId}/track-access/${templateId}/`,
  // Admin: close / split the fellow's open curriculum into a new program
  CAMPUS_MANAGE_START_NEW_PROGRAM: (userId: number | string): string =>
    `${BASE_URL}/personal-curriculum/manage/fellows/${userId}/start-new-program/`,

  // Graduation flow
  GRADUATION_STATUS: `${BASE_URL}/job_applications/graduation/status/`,
  GRADUATION_SUBMIT: `${BASE_URL}/job_applications/graduation/submit/`,
  GRADUATING_FELLOWS_LIST: `${BASE_URL}/job_applications/graduation/graduating-fellows/`,
  COMPLETED_FELLOWS_LIST: `${BASE_URL}/job_applications/graduation/completed-fellows/`,
  GRADUATION_NOTIFY_PROGRAM_COMPLETED: (userId: number | string): string =>
    `${BASE_URL}/job_applications/graduation/completed-fellows/${userId}/notify/`,
  GRADUATION_COMPLETE_PROGRAM: (userId: number | string): string =>
    `${BASE_URL}/job_applications/graduation/complete-program/${userId}/`,
  GRADUATION_PROGRAM_FLOW: (userId: number | string): string =>
    `${BASE_URL}/job_applications/graduation/program-flow/${userId}/`,
  GRADUATION_REFERRAL_PACKAGE: (userId: number | string): string =>
    `${BASE_URL}/job_applications/graduation/referral-package/${userId}/`,
  GRADUATION_GRADUATE: (userId: number | string): string =>
    `${BASE_URL}/job_applications/graduation/graduate/${userId}/`,

  // Resume File API Routes
  RESUME_FILES_LIST: `${BASE_URL}/job_applications/resume-files/`,
  RESUME_FILE_DETAIL: (id: string | number): string => `${BASE_URL}/job_applications/resume-files/${id}/`,
  RESUME_FILE_APPROVE: (id: string | number): string => `${BASE_URL}/job_applications/resume-files/${id}/approve/`,
  RESUME_FILE_SET_DEFAULT: (id: string | number): string => `${BASE_URL}/job_applications/resume-files/${id}/set-default/`,
} as const;
